import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useState } from 'react';
import barChart from '../../assets/images/bar_chart.svg';
import barChartSelected from '../../assets/images/bar_chart_selected.svg';
import lineChart from '../../assets/images/line_chart.svg';
import lineChartSelected from '../../assets/images/line_chart_selected.svg';
import { CHART_TYPES } from '../../constants';
import FormattedNumber from '../_components/formattedNumber';
import RatesTable from './RatesTable';

const RatesTab = ({
  parseFloatKeep,
  unit,
  showLastYearTaxes,
  showNotPublishedForZeroTaxRate,
  isUseTaxElectionRate,
  isWaterRate,
  openWorksheetPDF,
  buildLineChartConfig,
}) => {
  const [chartType, setChartType] = useState();

  useState(() => {
    setChartType(CHART_TYPES.COLUMN);
  }, []);

  return (
    <div>
      <div className='row chart-container'>
        <div className='col-12 col-sm-12 col-md-4 order-1 order-sm-1 order-md-last chart-wrapper'>
          <div
            className='row'
            style={{ justifyContent: 'flex-end', paddingRight: 15 }}
          >
            <button
              aria-label='Show bar chart'
              aria-pressed={chartType === CHART_TYPES.COLUMN}
              className='chart-toggle-btn'
              type='button'
              onClick={() => setChartType(CHART_TYPES.COLUMN)}
            >
              <img
                alt=''
                aria-hidden='true'
                src={
                  chartType === CHART_TYPES.COLUMN ? barChartSelected : barChart
                }
              />
            </button>
            <button
              aria-label='Show line chart'
              aria-pressed={chartType === CHART_TYPES.LINE}
              className='chart-toggle-btn'
              type='button'
              onClick={() => setChartType(CHART_TYPES.LINE)}
            >
              <img
                alt=''
                aria-hidden='true'
                src={
                  chartType === CHART_TYPES.LINE ? lineChartSelected : lineChart
                }
              />
            </button>
          </div>
          <HighchartsReact
            containerProps={{ 'data-testid': 'rates-chart' }}
            highcharts={Highcharts}
            immutable
            options={buildLineChartConfig(unit, chartType)}
          />
        </div>
        <div className='col-12 col-sm-12 col-md-8 order-2 order-sm-2 order-md-first rate-container'>
          <div className='main-rate-container'>
            <div style={{ position: 'relative' }}>
              <span className='sub-title'>Taxable Value: </span>
              <span>
                $
                <FormattedNumber value={parseFloatKeep(unit.taxableValue)} />
              </span>
            </div>
            {Boolean(showLastYearTaxes) && (
              <div>
                <span className='sub-title'>Last Year's Taxes: </span>
                <span>
                  $
                  <FormattedNumber value={parseFloatKeep(unit.lastYearTaxes)} />
                </span>
              </div>
            )}
          </div>
          {/* biome-ignore lint/a11y/noNoninteractiveTabindex: scrollable region must be keyboard-focusable (axe scrollable-region-focusable; e2e/keyboard-nav.spec.js) */}
          <div className='custom-scroll-wrapper' tabIndex='0'>
            <RatesTable
              isUseTaxElectionRate={isUseTaxElectionRate}
              isWaterRate={isWaterRate}
              openWorksheetPDF={openWorksheetPDF}
              parseFloatKeep={parseFloatKeep}
              showLastYearTaxes={showLastYearTaxes}
              showNotPublishedForZeroTaxRate={showNotPublishedForZeroTaxRate}
              unit={unit}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RatesTab;
